import React, { Component } from 'react';
import { fetchWithJson } from '../../utils/api';

import RecommendedCouponListItem from '../../components/RecommendedCouponListItem';

class RecommendedCouponsView extends Component {
  constructor(props) {
    super(props);

    this.loadMore = this.loadMore.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

    this.state = {
      coupons: props.coupons || [],
      hasNext: props.coupons && props.coupons.length > 0,
      isFetching: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.coupons && nextProps.coupons.length &&
      !(this.state.coupons && this.state.coupons.length)) {
      this.setState({
        coupons: nextProps.coupons
      });
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.loadMore();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (!this.state.hasNext && this.couponListDom) {
      const originDomHeight = this.couponListDom.offsetHeight + 46;
      if (originDomHeight <= window.innerHeight + window.document.body.scrollTop) {
        this.loadMore();
      }
    }
  }

  createKeyFromCoupon(coupon) {
    return `${coupon.id}-${coupon.entryEndAt}-${coupon.modifiedAt}`;
  }

  loadMore() {
    const { coupons, hasNext } = this.state;
    let since = null;

    if (coupons.length > 0) {
      since = this.createKeyFromCoupon(coupons[coupons.length - 1]);
    }

    const url = since === null ? `/api/talk/coupons` : `/api/talk/coupons?since=${since}`;

    this.setState({ isFetching: true });
    fetchWithJson(url).then(result => {
      const items = result.items;
      if (items) {
        this.setState({
          coupons: coupons.concat(items),
          isFetching: false
        });
      } else {
        this.setState({
          hasNext: false,
          isFetching: false
        });
      }
    });
  }

  render () {
    const { type, isFetching } = this.props;
    const { hasNext } = this.state;
    const coupons = this.state.coupons || [];

    if (!isFetching && !coupons.length) {
      return (
        <div className="wrap_coupon">
          <div>
            <span className="img_cont" />
            <strong className="tit_talk">응모가능한 쿠폰이 없습니다.</strong>
            <span className="txt_desc">나중에 다시 확인해주세요.</span>
          </div>
        </div>
      );
    }

    return (
      <div className="wrap_coupon" ref={( div ) => { this.couponListDom = div; }}>
        <ul className="list_coupon">
          {
            coupons.map(coupon =>
              <RecommendedCouponListItem key={coupon.id} type={type} coupon={coupon} />
            )
          }
          {
            isFetching && (
              <div className="wrap_coupon">
                <div className="foot_coupon">
                  <span className="ico_loading" />
                </div>
              </div>
            )
          }
        </ul>
      </div>
    );
  }
}

export default RecommendedCouponsView;



// WEBPACK FOOTER //
// ./src/containers/MorePage/recommendeds.js